export const sizeGuideImage = 'https://placehold.co/480x720/e8e4df/5c5346?text=Size+Guide';
export const sizeChartImage = 'https://placehold.co/480x720/d4cfc7/5c5346?text=Size+Chart';
